import { getRouter } from '@/utils';
import { routerBeforeEach } from './hooks/before-each';
import { routes } from './routes';

const router = getRouter(routes);

router.beforeEach(routerBeforeEach);
export default router;
